import { Navigate } from 'react-router-dom';
import HomePage from '../pages/home/page';
import CoursesPage from '../pages/courses/page';
import CourseDetailPage from '../pages/course-detail/page';
import LessonViewerPage from '../pages/lesson-viewer/page';
import DashboardPage from '../pages/dashboard/page';
import CertificatePage from '../pages/certificate/page';
import LoginPage from '../pages/auth/login/page';
import SignupPage from '../pages/auth/signup/page';
import NotFound from '../pages/NotFound';
import AdminLayout from '../pages/admin/components/AdminLayout';
import AdminDashboardPage from '../pages/admin/dashboard/page';
import AdminCoursesPage from '../pages/admin/courses/page';
import CourseEditorPage from '../pages/admin/course-edit/page';

const routes = [
  { path: '/', element: <HomePage /> },
  { path: '/courses', element: <CoursesPage /> },
  { path: '/courses/:id', element: <CourseDetailPage /> },
  { path: '/courses/:courseId/lesson/:lessonId', element: <LessonViewerPage /> },
  { path: '/dashboard', element: <DashboardPage /> },
  { path: '/certificate/:courseId', element: <CertificatePage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/signup', element: <SignupPage /> },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <Navigate to="/admin/dashboard" replace /> },
      { path: 'dashboard', element: <AdminDashboardPage /> },
      { path: 'courses', element: <AdminCoursesPage /> },
      { path: 'courses/new', element: <CourseEditorPage /> },
      { path: 'courses/:id/edit', element: <CourseEditorPage /> },
    ],
  },
  { path: '*', element: <NotFound /> },
];

export default routes;
